import React from 'react';
import './Footer.css';
import { useTranslation } from 'react-i18next';

import img1 from '../../assets/projects/1/4.jpg';
import img2 from '../../assets/projects/2/22.jpg';
import img3 from '../../assets/projects/4/51.jpg';
import img4 from '../../assets/projects/5/81.jpg';
import img5 from '../../assets/projects/8/118.jpg';
import img6 from '../../assets/projects/9/123.jpeg';

import youtubeIcon from '../../assets/social-icons/youtube.png';
import linkedinIcon from '../../assets/social-icons/linkedin.png';
import tiktokIcon from '../../assets/social-icons/tiktok.png';
import snapchatIcon from '../../assets/social-icons/snapshat.png';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="footer-section">
      <div className="footer-container">

        <div className="footer-col about">
          <h3>{t('footer.aboutTitle')}</h3>
          <p>{t('footer.aboutText')}</p>
          <div className="social-icons">
            <a href="#"><img src={youtubeIcon} alt={t('footer.youtubeAlt')} /></a>
            <a href="#"><img src={linkedinIcon} alt={t('footer.linkedinAlt')} /></a>
            <a href="#"><img src={tiktokIcon} alt={t('footer.tiktokAlt')} /></a>
            <a href="#"><img src={snapchatIcon} alt={t('footer.snapchatAlt')} /></a>
          </div>
        </div>

        <div className="footer-col links">
          <h3>{t('footer.quickLinksTitle')}</h3>
          <ul>
            <li><a href="#home">{t('footer.homeLink')}</a></li>
            <li><a href="#about">{t('footer.aboutLink')}</a></li>
            <li><a href="#services">{t('footer.servicesLink')}</a></li>
            <li><a href="#projects">{t('footer.projectsLink')}</a></li>
            <li><a href="#clients">{t('footer.clientsLink')}</a></li>
            <li><a href="#contact">{t('footer.contactLink')}</a></li>
          </ul>
        </div>

        <div className="footer-col address">
          <h3>{t('footer.addressTitle')}</h3>
          <div className="map-embed">
  <iframe
    title={t('footer.mapTitle')}
    src="https://www.google.com/maps/embed?pb=!1m13!1m8!1m3!1d51068.39206060553!2d46.757115!3d24.7447975!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjTCsDQ0JzQxLjMiTiA0NsKwNDUnMjUuNiJF!5e1!3m2!1sar!2seg!4v1753064103556!5m2!1sar!2seg"
    width="100%"
    height="200"
    style={{ border: 0 }}
    allowFullScreen=""
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
  ></iframe>
</div>

          <p>{t('footer.addressText')}</p>
        </div>

        <div className="footer-col gallery">
          <h3>{t('footer.ourWorkTitle')}</h3>
          <div className="gallery-grid">
            {[img1, img2, img3, img4, img5, img6].map((img, idx) => (
              <img key={idx} src={img} alt={t('footer.workImageAlt', { number: idx + 1 })} />
            ))}
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;